import { useGetCoursePlanQuery, useGetEvaluationQuery } from '@teachur/http-client';
import type { CompletedDegree, DegreePlan } from '@teachur/http-client';

export const useCoursePlan = () => {
  const evaluationQuery = useGetEvaluationQuery();
  const wizardComplete = evaluationQuery.data?.priorEducationStatus != null;

  const savedQuery = useGetCoursePlanQuery({ enabled: wizardComplete });

  const plans: DegreePlan[] = savedQuery.data?.plans ?? [];
  const completedDegrees: CompletedDegree[] = savedQuery.data?.completedDegrees ?? [];

  const retry = () => {
    if (evaluationQuery.isError) {
      void evaluationQuery.refetch();
    }
    if (savedQuery.isError) {
      void savedQuery.refetch();
    }
  };

  return {
    wizardComplete,
    isLoading: evaluationQuery.isLoading || (wizardComplete && savedQuery.isLoading),
    isError: evaluationQuery.isError || (wizardComplete && savedQuery.isError),
    plans,
    completedDegrees,
    retry,
  };
};
